'use client';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-container footer-top">
        {/* Brand col */}
        <div className="footer-brand-col">
          <a href="/" className="brand footer-brand">
            <span className="brand-mark">
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round">
                <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
                <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
                <path d="M7 21h10" />
                <path d="M12 3v18" />
                <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
              </svg>
            </span>
            <span>
              <strong>Harrington &amp; Associates</strong>
              <em>LLP</em>
            </span>
          </a>
          <p>
            Precision counsel. Powerful results.<br />
            Trusted advocates for over two decades.
          </p>
        </div>

        {/* Contact */}
        <div>
          <p className="footer-label">Contact</p>
          <a href="tel:+19177374049">(917) 737-4049</a>
          <a href="mailto:info@harringtonlaws.com">info@harringtonlaws.com</a>
          <p>
            350 Fifth Avenue, Suite 4100<br />
            New York, NY 10118
          </p>
        </div>

        {/* Practice Areas */}
        <div>
          <p className="footer-label">Practice Areas</p>
          <a href="#practice-areas">Personal Injury</a>
          <a href="#practice-areas">Business Law</a>
          <a href="#practice-areas">Family Law</a>
          <a href="#practice-areas">Employment Law</a>
          <a href="#practice-areas">Real Estate</a>
          <a href="#practice-areas">Criminal Defense</a>
        </div>

        {/* The Firm */}
        <div>
          <p className="footer-label">The Firm</p>
          <a href="#our-firm">About Us</a>
          <a href="#attorneys">Our Attorneys</a>
          <a href="#selected-matters">Selected Matters</a>
          <a href="#client-reviews">Client Reviews</a>
          <a href="#contact">Free Consultation</a>
          <a href="#contact">Contact</a>
          <a href="/privacy-policy">Privacy Policy</a>
        </div>
      </div>

      <div className="site-container footer-bottom">
        <p>&copy; 2025 Harrington & Associates LLP. All rights reserved.</p>
        <p>
          Attorney Advertising. Prior results do not guarantee a similar outcome. This website is for general information purposes only and does not constitute legal advice.{' '}
          <a href="/privacy-policy" style={{ color: 'var(--gold-soft)', textDecoration: 'underline', textUnderlineOffset: '3px' }}>Privacy Policy</a>
        </p>
      </div>
    </footer>
  );
}
